import React from 'react';
import { Dimensions, Platform, View } from 'react-native';
import Toast from 'react-native-toast-message';
import { UnistylesRuntime } from 'react-native-unistyles';

import { isDesktop } from '@/core';
import { Text } from '@/ui';

import { Icon } from './icon';
import { Cancel } from './icons/cancel';
import { Checkmark } from './icons/checkmark';

export const IS_IOS = Platform.OS === 'ios';
const { width, height } = Dimensions.get('screen');

export const WIDTH = width;
export const HEIGHT = height;

export const toastConfig = {
  success: ({ text1, props }) => (
    <View
      style={{
        minHeight: 80,
        maxWidth: isDesktop() ? 500 : '80%',
        backgroundColor:
          UnistylesRuntime.themeName === 'dark'
            ? 'rgba(17, 35, 18, 1)'
            : 'rgba(223, 255, 226, 1)',
        padding: 24,
        gap: 4,
        borderRadius: 16,
        flexDirection: 'row',
        justifyContent: 'center',
        borderWidth: 1,
        borderColor:
          UnistylesRuntime.themeName === 'dark'
            ? 'rgba(111, 236, 123, 1)'
            : 'rgba(65, 212, 79, 1)',
      }}
    >
      <View
        style={{ flex: 1, flexDirection: 'row', alignItems: 'center', gap: 8 }}
      >
        <Icon
          type="naked"
          icon={<Checkmark />}
          fillColor={
            UnistylesRuntime.themeName === 'dark'
              ? 'rgba(111, 236, 123, 1)'
              : 'rgba(0, 170, 16, 1)'
          }
          width={12}
          height={12}
        />

        <Text type="bodyRegular">{text1}</Text>
      </View>
    </View>
  ),
  error: ({ text1, props }) => (
    <View
      style={{
        minHeight: 80,
        maxWidth: isDesktop() ? 500 : '80%',
        backgroundColor:
          UnistylesRuntime.themeName === 'dark'
            ? 'rgba(38, 12, 21, 1)'
            : 'rgba(255, 221, 234, 1)',
        padding: 24,
        gap: 4,
        borderRadius: 16,
        flexDirection: 'row',
        justifyContent: 'center',
        borderWidth: 1,
        borderColor:
          UnistylesRuntime.themeName === 'dark'
            ? 'rgba(255, 80, 143, 1)'
            : 'rgba(255, 0, 92, 0.15)',
      }}
    >
      <View
        style={{ flex: 1, flexDirection: 'row', alignItems: 'center', gap: 8 }}
      >
        <Icon
          type="naked"
          icon={<Cancel />}
          fillColor={
            UnistylesRuntime.themeName === 'dark'
              ? 'rgba(255, 80, 143, 1)'
              : 'rgba(255, 0, 92, 1)'
          }
          width={12}
          height={12}
        />

        <Text type="bodyRegular">{text1}</Text>
      </View>
    </View>
  ),
};

export const showErrorMessage = (message: string = 'Something went wrong ') => {
  Toast.show({
    type: 'error',
    text1: message,
    visibilityTime: 4000,
  });
};

export const extractError = (data: unknown): string => {
  if (typeof data === 'string') {
    return data;
  }
  if (Array.isArray(data)) {
    const messages = data.map((item) => {
      return `  ${extractError(item)}`;
    });

    return `${messages.join('')}`;
  }

  if (typeof data === 'object' && data !== null) {
    const messages = Object.entries(data).map((item) => {
      const [key, value] = item;
      const separator = Array.isArray(value) ? ':\n ' : ': ';

      return `- ${key}${separator}${extractError(value)} \n `;
    });
    return `${messages.join('')} `;
  }
  return 'Something went wrong ';
};
